import { Mapping } from 'api/MappingsAPI';
import { DataTypeType } from 'modules/domains';

export const getAggregateFieldsByDataType =
  (fields: Mapping[]) => (selectedDataType?: DataTypeType) =>
    fields.filter(({ dataType }) => dataType === selectedDataType);
